import React, { useState } from 'react';
import { auth, db } from '../../../firebase';
import { EmailAuthProvider, reauthenticateWithCredential, verifyBeforeUpdateEmail } from 'firebase/auth';
import { doc, updateDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import '../login_page/forgot_password.css'; // Reuses your existing authentication layout styles

const UpdateEmailPage = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEmailUpdate = async (e) => {
    e.preventDefault();
    
    const user = auth.currentUser;

    const actionCodeSettings = {
      url: 'https://parm.com.my/auth-handler', 
      handleCodeInApp: true,
    };
    
    // Safety Guard: Ensure user is actually logged in before trying to change properties
    if (!user) {
      alert("Session expired. Please log in again.");
      navigate('/login-parm');
      return;
    }

    if (newEmail.trim().toLowerCase() === user.email.toLowerCase()) {
      return alert("The new email address cannot match your current active email.");
    }

    setLoading(true);

    try {
      // 1. Re-authenticate the user using their current active email and input password
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      console.log("🔒 Identity re-authenticated successfully.");

      // 2. 🟢 TRIGGER THE VERIFICATION DISPATCHER LINK
      // await verifyBeforeUpdateEmail(user, newEmail.trim());
      await verifyBeforeUpdateEmail(user, newEmail.trim());

      // 3. Mirror the update to your Firestore registrations collection
      const userRef = doc(db, "registrations", user.uid);
      await updateDoc(userRef, { 
        email: newEmail.trim().toLowerCase() 
      });
      console.log("✅ Firestore collection profile record updated.");

      alert("A verification link has been sent to your new email address! Please check spam folder.");
      
      // Send them back to their dashboard or login page while they wait for the link
      navigate('/member-dashboard-parm'); 

    } catch (error) {
      console.error("Email update workflow exception:", error);
      alert("Failed to initiate email change: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="forgot-password-container">
      <form className="forgot-form" onSubmit={handleEmailUpdate}>
        <h2>Update Account Email</h2>
        <p>Confirm your current password and specify your new preferred contact identity email link below.</p>

        {/* Current Active User Profile (Read Only Context Indicator) */}
        <div className="input-group-forgot-form" style={{ opacity: 0.7 }}>
          <label>Current Email Address</label>
          <input 
            type="text" 
            value={auth.currentUser?.email || "Not Authenticated"} 
            disabled 
            style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed' }}
          />
        </div>

        {/* Field 1: Security Verification Input */}
        <div className="input-group-forgot-form">
          <label>Confirm Current Password</label>
          <input 
            type="password" 
            placeholder="••••••••"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            required 
          />
        </div>

        {/* Field 2: Target Email Input Element */}
        <div className="input-group-forgot-form">
          <label>New Target Email Address</label>
          <input 
            type="email" 
            placeholder="new-email@mail.com"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            required 
          />
        </div>

        <button type="submit" className="reset-btn-forgotpass" disabled={loading}>
          {loading ? "Processing Link..." : "Send Verification Email"}
        </button>

        <button 
          type="button" 
          className="back-btn-forgotpass" 
          onClick={() => navigate('/member-dashboard-parm')}
          style={{ marginTop: '10px' }}
        >
          Cancel & Return to Dashboard
        </button>
      </form>
    </div>
  );
};

export default UpdateEmailPage;